module.exports = __webpack_public_path__ + "img/reward_LARIX@2x.f1f0eda2.png";